module.exports = __webpack_public_path__ + "static/media/webAlert.e56a69b8.svg";